import { z } from 'zod';
import { parseFrontmatter } from './frontmatter';
const SKILL_NAME_PATTERN = /^[a-z0-9]+(?:-[a-z0-9]+)*$/;
/** A skill an organization writes for Via. The description says when it applies; Via reads it to decide. */
export const viaSkillInputSchema = z.object({
    name: z
        .string()
        .trim()
        .min(1, 'Name is required')
        .max(64, 'Keep the name under 64 characters')
        .regex(SKILL_NAME_PATTERN, 'Use lowercase letters, numbers and hyphens'),
    description: z
        .string()
        .trim()
        .min(1, 'Description is required')
        .max(500, 'Keep the description under 500 characters'),
    instructions: z
        .string()
        .trim()
        .min(1, 'Instructions are required')
        .max(20_000, 'Keep the instructions under 20,000 characters'),
    enabled: z.boolean().default(true)
});
export const MAX_ORGANIZATION_SKILLS = 50;
/** The enabled skills the browser sends with each chat. They're kept in the browser until they're stored per organization. */
export const viaOrganizationSkillsSchema = z
    .array(viaSkillInputSchema.omit({ enabled: true }))
    .max(MAX_ORGANIZATION_SKILLS, `Enable at most ${MAX_ORGANIZATION_SKILLS} skills`);
const toSkillName = (text) => text
    .toLowerCase()
    .replace(/\.md$/, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
/** Reads a SKILL.md-style file: `name` and `description` frontmatter, instructions in the body. */
export const parseViaSkillMarkdown = (fileName, raw) => {
    const { field, body } = parseFrontmatter(raw.replace(/\r\n/g, '\n'));
    return {
        name: toSkillName(field('name') ?? fileName),
        description: field('description') ?? '',
        instructions: body
    };
};
//# sourceMappingURL=org-skills.js.map